import {
  IOrderDetailOutput,
  IOrderPermanentCouponOutput,
  IOrderRepayOutput,
} from "@types";
import gate from "../gate";
import client from "../http-clients/api";

const orderApi = {
  orderDetail: (order_id: string, params?: any) =>
    gate.get<IOrderDetailOutput, never, any>({
      client,
      url: `/order/show/${order_id}`,
      params,
    }),
  repay: (order_id: number) =>
    gate.post<IOrderRepayOutput, never, any>({
      client,
      url: `order/repayment/${order_id}`,
      params: { platform: "web" },
    }),
  permentCoupon: () =>
    gate.get<IOrderPermanentCouponOutput, never, any>({
      client,
      url: "order/permanent/show",
    }),
};

export default orderApi;
